import { Sprite } from 'pixi.js';
import { createBitmapText } from '../../Utils/Utils';
import Container = PIXI.Container;

export class LifeDisplay extends Container {
    constructor(lifeAmt: number, broken: boolean = false) {
        super();

        const icon = broken ? 'commonui/icon-heart-broken' : 'gameui/icon-heart';
        const bg = new Sprite(PIXI.utils.TextureCache[icon]);
        bg.anchor.set(0.5);
        const lifeNumText = createBitmapText(
            lifeAmt.toString(10),
            new PIXI.Rectangle(0, 0, bg.width * 0.3, bg.height * 0.2),
            'riffic'
        );
        lifeNumText.anchor = 0.5;

        //@ts-ignore
        this.addChild(bg, lifeNumText);
    }
}
